import React from 'react';
import Header from './components/Header';
import Navigation from './components/Navigation';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Resume from './components/Resume';
import Footer from './components/Footer';
import Style from './styles/main.css';
function App() {
  return (
    <div className="App">
      <Header />
      <Navigation />
      <About />
      <br />
      <br />
      <br />
      <br />
      <Portfolio />
      <br />
      <br />
      <br />
      <br />
      <Contact />
      <br />
      <br />
      <br />
      <br />
      <Resume />
      <br />
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default App;


